<template>
  <tbody v-if="(max === Infinity || index < max) && (min === -1 || index > min)">
    <tr>
        <td class="border-b-0">
          <button type="button" class="btn text-orange" @click="$emit('openItemHistory', item.product)" v-if="allowActions">
            <i class="fas fa-history"></i>
          </button>
          {{ item.product.name }}
          <small class="font-bold text-red-500">{{ item.product.code }}</small>
        </td>
        <td>{{ item.description }}</td>
        <td>{{ item.quantity }}</td>
        <td>{{ $formatMoney(item.value) }}</td>
        <td>{{ item.discount }}%</td>
        <td>{{ item.tax }}%</td>
        <td class="text-right">
          <p class="m-0">
            {{ $formatMoney(item.total.all) }}
          </p>
          <p class="m-0 total-details" v-if="item.total.discount">
            <strong>Dis.</strong>
            {{ $formatMoney(item.total.discount) }}
          </p>
          <p class="m-0 total-details" v-if="item.total.tax">
            <strong>Tax</strong>
            {{ $formatMoney(item.total.tax) }}
          </p>
        </td>
        <td class="text-center" v-if="allowActions">
          <div class="flex">
            <span class="btn btn-blue text-xs py-2 px-3" @click="$emit('edit', index)">
              <i class="fas fa-edit"></i>
            </span>
            <span class="btn btn-red text-xs py-2 px-3 ml-2" @click="$emit('remove', index)">
              <i class="fas fa-trash"></i>
            </span>
          </div>
        </td>
    </tr>
    <tr class="text-right text-red-500 warnings" v-if="item.priceWarnings">
      <td colspan="8">
        <i class="fas fa-exclamation-triangle"></i>
        <span class="ml-2">{{ item.priceWarnings }}</span>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    item: {},
    index: Number,
    min: {
      type: Number,
      default: -1,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    allowActions: Boolean,
  },
}
</script>
